import { Flex, Button, ButtonGroup, Input, InputGroup, InputRightAddon } from '@vitvio/design-system';
import { useMutation } from 'react-relay';
import { updateTimeInputCreateEstimateMutationShard } from './update-time-input-create-estimate';

import { addMinutes, dayjs } from '@vitvio/helpers';
import { fromGlobalID } from '@vitvio/global-id';
import { useState } from 'react';

interface TimerContentPanelProps {
  jobId: string;
}
export function UpdateTimeInput({ jobId }: TimerContentPanelProps) {
  const buttonTimeInputOptions = new Array(12).fill(0).map((_, i) => {
    return 5 + i * 5;
  });

  const [input, setInput] = useState<string | number>('');

  const [commit, isInFlight] = useMutation(updateTimeInputCreateEstimateMutationShard);

  async function handleCreateEstimate(time: number) {
    const timeToUpdateOn = addMinutes(dayjs(), time);

    await new Promise((resolve, reject) => {
      commit({
        variables: {
          connections: [],
          input: {
            estimate: timeToUpdateOn?.toISOString() ?? dayjs().toISOString(),
            jobId: fromGlobalID(jobId).id,
          },
        },
        onCompleted: (res) => {
          resolve(res);
        },
        onError: (err) => {
          reject(err);
        },
      });
    });
  }

  function handleSubmit(e: React.FormEvent<HTMLDivElement>) {
    e.preventDefault();
    handleCreateEstimate(Number(input));
    setInput('');
  }

  function handleInput(e: React.ChangeEvent<HTMLInputElement>) {
    const num = Number(e.target.value);
    if (num === 0) {
      setInput('');
      return;
    } else if (isNaN(num)) {
      setInput('');
    } else {
      setInput(num);
    }
  }
  return (
    <Flex flexDir={'column'} gap={'16px'} as={'form'} onSubmit={handleSubmit}>
      <ButtonGroup>
        {buttonTimeInputOptions.map((time) => (
          <Button
            key={time}
            value={time}
            isDisabled={isInFlight}
            onClick={(e) => handleCreateEstimate(parseInt((e.target as HTMLButtonElement).value, 10))}
            fontWeight={'regular'}
          >
            {time}m
          </Button>
        ))}
      </ButtonGroup>

      <InputGroup w={'25%'}>
        <Input placeholder="Enter minutes" value={input} onChange={handleInput} isDisabled={isInFlight} type="number" />
        {input && (
          <InputRightAddon
            cursor={isInFlight ? 'not-allowed' : 'pointer'}
            _hover={{ bg: 'gray.200' }}
            onClick={handleSubmit}
            fontWeight={'bolder'}
            pointerEvents={isInFlight ? 'none' : 'auto'}
          >
            Submit
          </InputRightAddon>
        )}
      </InputGroup>
    </Flex>
  );
}
